export default defineNuxtPlugin(_nuxtApp => {
  // Reserved for future router-level concerns (auth guards, telemetry,
  // etc). The previous after-each that pinged the recent-updates stats
  // is gone — `useLatestUpdates` handles polling on its own with
  // visibility + event invalidation.
})
